import { memo } from 'react';
import {
  Group,
  Text,
  LoadingOverlay,
  Badge,
  Stack,
  Avatar,
} from '@mantine/core';
import type { UserInfo } from '../../services/userManager';

interface UserInfoSectionProps {
  userInfo: UserInfo | null;
  loadingUserInfo: boolean;
}

export const UserInfoSection = memo<UserInfoSectionProps>(
  ({ userInfo, loadingUserInfo }) => {
    return (
      <div style={{ position: 'relative', marginBottom: '1rem' }}>
        <LoadingOverlay visible={loadingUserInfo} />

        {/* User Info - Compact */}
        <Group gap='md' align='center'>
          {/* Avatar */}
          <Avatar
            size={60}
            radius='md'
            style={{
              border: '2px solid var(--mantine-color-blue-1)',
              flexShrink: 0,
              backgroundColor: 'var(--mantine-color-blue-0)',
              color: 'var(--mantine-color-blue-6)',
              fontWeight: 600,
              fontSize: '1.2rem',
            }}
          >
            {userInfo?.first_name?.[0] || 'U'}
          </Avatar>

          {/* User Details */}
          <Stack gap='xs' style={{ flex: 1 }}>
            {/* First Row: Name and Type */}
            <Group gap='xs' align='center'>
              <Text fz='lg' fw={700} c='dark'>
                {userInfo?.first_name} {userInfo?.last_name}
              </Text>
              <Badge
                color='blue'
                variant='light'
                size='sm'
                style={{ textTransform: 'uppercase', fontWeight: 600 }}
              >
                {userInfo?.type || 'Utente'}
              </Badge>
            </Group>

            {/* Second Row: Email and ID */}
            <Group gap='sm' align='center'>
              <Text fz='sm' c='dark'>
                {userInfo?.email || 'Email non disponibile'}
              </Text>
              {userInfo?.id && (
                <>
                  <Text fz='xs' c='dimmed'>
                    •
                  </Text>
                  <Text fz='xs' c='dimmed' ff='monospace'>
                    ID: {userInfo.id}
                  </Text>
                </>
              )}
            </Group>
          </Stack>
        </Group>
      </div>
    );
  }
);

UserInfoSection.displayName = 'UserInfoSection';
